<template>
  <div class="ui dimmer" :class="{ inverted: inverted, active: dimmed }">
    <slot>
      <loader v-if="dimmed" :active="dimmed"></loader>
    </slot>
  </div>
</template>

<script>
import Loader from './Loader'

/**
 * @class Dimmer
 *
 * @description This component dims the view where it's necessary
 */
export default {
  name: 'Dimmer',
  components: {
    Loader,
  },
  props: {
    dimmed: {
      type: Boolean,
      default: false,
    },
    inverted: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped lang="scss"></style>
